import { render } from "./receipt_no_data.vue?vue&type=template&id=f784a8d8"
import script from "./receipt_no_data.vue?vue&type=script&lang=js"
export * from "./receipt_no_data.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__